import React, { useState } from 'react';

function Extramaterial({ currentMaterial, materials, setCurrentMaterial, setMaterials }) {
  const [showForm, setShowForm] = useState(false);

  const materialPriceRanges = {
    "copper_piping_p": { min: 349, max: 449 },
    "copper_piping_cassette_p": { min: 449, max: 499 },
    "core_cable_4_p": { min: 30, max: 50 },
    "l_stand_p": { min: 599, max: 999 },
    "cross_stand_p": { min: 1600, max: 1800 },
    "rubber_stand_p": { min: 299, max: 299 },
    "dismantling_charges_p": { min: 500, max: 500 },
    "uninstall_cassette_charges":{min:1500,max:1999},
    "jumbo_stand":{min:999,max:1099},
    "add_on_split":{min:499,max:499},
    "add_on_cassette":{min:1499,max:1999},
    "relocation_split":{min:2000,max:2000},
    "relocation_cassette":{min:5000,max:6000}
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
  
    setCurrentMaterial((prevMaterial) => {
      if (id === 'materialType') {
        // Get the min and max values based on the selected material type
        const { min, max } = materialPriceRanges[value] || { min: 0, max: 0 };
        
        // Check if the material type is 'l_stand_p' and set the price to min
        const price = value === 'l_stand_p' ? min : max;
  
        return {
          ...prevMaterial,
          materialType: value,
          quantity: '1',
          price: price, // Use min value for l_stand_p, max for others
          totalAmount: price // Set totalAmount based on the price
        };
      }
  
      const updatedMaterial = {
        ...prevMaterial,
        [id]: value
      };
      
      if (id === 'quantity' || id === 'price') {
        updatedMaterial.totalAmount = (updatedMaterial.quantity || 1) * (updatedMaterial.price || 0);
      }
  
      return updatedMaterial;
    });
  };
  

  const handlePriceBlur = () => {
    const { materialType, price } = currentMaterial;
    const priceValue = parseFloat(price);
  
    if (materialType && priceValue) {
      const { min } = materialPriceRanges[materialType] || { min: 0 };
  
      if (priceValue < min) {
        alert(`Price for ${materialType} should not be less than ${min}`);
        setCurrentMaterial((prevMaterial) => ({
          ...prevMaterial,
          price: min
        }));
      }
    }
  };
  

  const addMaterial = () => {
    const totalAmount = currentMaterial.quantity * currentMaterial.price;

    if (!currentMaterial.materialType || !currentMaterial.quantity || !currentMaterial.price) {
      alert('Please fill in all fields');
      return;
    }

    setMaterials((prevMaterials) => [
      ...prevMaterials,
      { ...currentMaterial, totalAmount }
    ]);

    setCurrentMaterial({
      materialType: '',
      quantity: '',
      price: '',
      totalAmount: ''
    });
    setShowForm(false);
  };

  const handleRemove = (index) => {
    setMaterials((prevMaterials) => prevMaterials.filter((_, i) => i !== index));
  };

  const isFeetMaterial = currentMaterial.materialType === 'copper_piping' || currentMaterial.materialType === 'core_cable_4';


  const materialTypeMapping = {
    copper_piping_p: "Copper Piping Split",
    copper_piping_cassette_p: "Copper Piping Cassette",
    l_stand_p: "L Stand",
    rubber_stand_p: "Rubber Stand",
    dismantling_charges_p: "Uninstallation",
    core_cable_4_p: "Polycab 4 Core Wire",
    cross_stand_p: "Cross Stand",
    jumbo_stand:"Jumbo_stand",
    uninstall_cassette_charges:"Cassete Ac Uninstallation",
    add_on_split:"Add On split service",
    add_on_cassette:"Add on Cassete service",
    relocation_cassette:"Relocation Cassete",
    relocation_split:"Relocation Split"

};

  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <h1 className="font-semibold text-lg">Extra Materials</h1>
      
      {materials.length > 0 && (
        <div className="mt-6">
          <div className="flex flex-wrap gap-4">
            {materials.map((item, index) => (
              <div
                key={index}
                className="border border-primary p-4 rounded-2xl w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 flex flex-col justify-between"
              >
                {materialTypeMapping[item.materialType] || "Unknown Material"}
                <p>Quantity: {item.quantity} {isFeetMaterial ? 'feet' : ''}</p>
                <p>Price: {item.price}</p>
                <p>Total Amount: {item.totalAmount}</p>
                <button
                  onClick={() => handleRemove(index)}
                  className="mt-4 bg-red-500 text-white font-normal py-2 px-4 rounded">
                  Remove
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded">
          + Add Material
        </button>
      )}

      {showForm && (
        <div className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <div>
              <label htmlFor="materialType" className="block font-semibold mb-2">Materials type:</label>
              <select
                id="materialType"
                value={currentMaterial.materialType}
                onChange={handleInputChange}
                className="w-full border-2 border-gray-300 rounded py-2 px-4">
                <option value="">Select a material</option>
                <option value="copper_piping_p">Copper Piping Split</option>
                <option value="copper_piping_cassette_p">Copper Piping Cassette</option>
                <option value="l_stand_p">L Stand</option>
                <option value="rubber_stand_p">Rubber Stand</option>
                <option value="dismantling_charges_p">Split AC Uninstallation</option>
                <option value="core_cable_4_p">Polycab 4 Core Wire</option>
                <option value="cross_stand_p">Cross Stand</option>
                <option value="jumbo_stand">Jumbo_stand</option>
                <option value="uninstall_cassette_charges">Cassete Ac Uninstallation</option>
                <option value="add_on_split">Add On split service</option>
                <option value="add_on_cassette">Add on Cassete service</option>
                <option value="relocation_cassette">Relocation Cassete</option>
                <option value="relocation_split">Relocation Split</option>
              </select>
            </div>

            <div>
              <label htmlFor="quantity" className="block font-semibold mb-2">
                Quantity{isFeetMaterial ? ' (feet)' : ''}:
              </label>
              <input
                id="quantity"
                type="text"
                value={currentMaterial.quantity}
                onChange={handleInputChange}
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                required
              />
            </div>

            <div>
              <label htmlFor="price" className="block font-semibold mb-2">Price:</label>
              <input
                id="price"
                type="text"
                value={currentMaterial.price}
                onChange={handleInputChange}
                onBlur={handlePriceBlur}
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                required
              />
            </div>

            <div>
              <label htmlFor="totalAmount" className="block font-semibold mb-2">Total amount:</label>
              <input
                type="text"
                value={currentMaterial.quantity*currentMaterial.price}
                disabled
                className="w-full border-2 border-gray-300 rounded py-2 px-4 bg-gray-100"
              />
            </div>
          </div>

          <button
            onClick={addMaterial}
            className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded">
            Save Material Details
          </button>
        </div>
      )}
    </div>
  );
}

export default Extramaterial;

